module.exports = __webpack_public_path__ + "static/media/landing-bg.011b6ba4.png";